import mixpanel from "mixpanel-browser";
import { mixpanel_token } from "../config/app";
import { getCookie } from "./cookie";

// Mixpanel never receives page URLs, which can carry tokens
// (sellsmart-api#4334 S5.4, ADR-13).
const MIXPANEL_CONFIG = {
  property_blacklist: ["$current_url", "$initial_referrer", "$referrer"],
};

interface eventTrackerInterface {
  event: string;
  properties?: any;
  auth?: boolean;
}

const eventTracker = (params: eventTrackerInterface) => {
  const { event, properties, auth } = params;

  try {
    mixpanel.init(mixpanel_token, MIXPANEL_CONFIG);

    if (auth) {
      const { id } = getCookie("auth");
      mixpanel.identify(id);
    }

    if (properties !== undefined) {
      mixpanel.track(event, properties);
    } else {
      mixpanel.track(event);
    }
  } catch (error) {}
};

const resetMixpanel = () => {
  try {
    mixpanel.init(mixpanel_token, MIXPANEL_CONFIG);
    mixpanel.reset();
  } catch (error) {}
};

export { eventTracker, resetMixpanel };
